import { Briefcase, Hammer, Layers, TrendingUp } from 'lucide-react';
import { LAUNCH_WHY } from '@/data/launch';
import { Reveal } from '../Reveal';

const ACCENT = '#4225C4';
const ACCENT_SOFT = '#E4E0FA';

const PRINCIPLE_ICONS = {
  briefcase: Briefcase,
  layers: Layers,
  hammer: Hammer,
  'trending-up': TrendingUp,
};

export const WhyBuild = () => (
  <section aria-labelledby="why-build-heading" data-testid="why-build-section" className="bg-mist py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal>
          <p className="flex items-center gap-3">
            <span className="font-mono text-xs font-medium tracking-widest" style={{ color: ACCENT }}>07</span>
            <span className="text-xs font-bold uppercase tracking-[0.2em]" style={{ color: ACCENT }}>
              {LAUNCH_WHY.eyebrow}
            </span>
          </p>
          <h2 id="why-build-heading" className="mt-4 text-balance text-3xl font-extrabold tracking-tight text-navy-900 sm:text-4xl">
            {LAUNCH_WHY.heading}
          </h2>
          <p className="mt-5 max-w-lg text-base leading-relaxed text-slate-600 sm:text-lg">{LAUNCH_WHY.copy}</p>

          <ul className="mt-10 space-y-7">
            {LAUNCH_WHY.principles.map((p) => {
              const Icon = PRINCIPLE_ICONS[p.icon];
              return (
                <li key={p.title} className="flex items-start gap-4" data-testid={`why-principle-${p.icon}`}>
                  <span
                    className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg"
                    style={{ backgroundColor: ACCENT_SOFT, color: ACCENT }}
                  >
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span>
                    <h3 className="text-lg font-extrabold tracking-tight text-navy-900">{p.title}</h3>
                    <p className="mt-1.5 max-w-md text-sm leading-relaxed text-slate-600 sm:text-base">{p.text}</p>
                  </span>
                </li>
              );
            })}
          </ul>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="overflow-hidden rounded-xl border border-slate-200 shadow-lift">
            <img
              src={LAUNCH_WHY.image.src}
              alt={LAUNCH_WHY.image.alt}
              width={LAUNCH_WHY.image.width}
              height={LAUNCH_WHY.image.height}
              loading="lazy"
              data-testid="why-build-image"
              className="aspect-[4/3] w-full object-cover"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
